<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="black">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center px-6>
      <v-flex xs12 lg12 pt-10 text-left>
        <span style="font-size: 25px;font-weight: bolder;">APPLY PASSBOOK</span>
      </v-flex>
    </v-layout>

    <v-layout wrap justify-center>
      <v-flex lg4>


        <v-card>
          <v-layout wrap justify-center pa-8 pt-8>
            <v-flex xs12 sm12 md12 lg12>
              <v-layout wrap justify-center>
                <v-flex xs12 sm12 md12 lg12 pb-3>
                  <span style="
                      font-size: 24px;
                      font-weight: 600;
                    ">New Passbook
                  </span>
                </v-flex>

                <v-flex xs12 sm12 md12 lg12>
                  <v-layout wrap justify-center>

                    <v-flex xs12 sm12 md12 lg12>
                      <span style="
                      font-size: 16px;
                      font-weight: 500;
                    ">
                        Division
                      </span>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12 pt-1 pb-4>
                      <v-autocomplete clearable dense outlined label="Division" color="black" :items="division"
                      v-model="divisionid" item-text="officeName" item-value="_id" item-color="#FF1313" hide-details="auto"
                      class="custom-autocomplete mainfont">
                      <template v-slot:label>
                        <span class="custom-label-text" style="color: black; font-size: 14px">
                          Division
                        </span>
                      </template>
                      <template v-slot:append>
                        <v-icon color="black">mdi-chevron-down</v-icon>
                      </template>
                    </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md12 lg12>
                  <v-layout wrap justify-center>

                    <v-flex xs12 sm12 md12 lg12>
                      <span style="
                      font-size: 16px;
                      font-weight: 500;
                    ">
                        PMR Number
                      </span>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12 pt-1 pb-4>
                      <v-text-field outlined placeholder="Folder Name" dense color="black"
                        v-model="pmrNo" item-text="name" item-value="name" hide-details="auto" clearable
                        >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>


                <v-flex xs12 sm12 md12 lg12>
                  <v-layout wrap justify-center>

                    <v-flex xs12 sm12 md12 lg12>
                      <span style="
                      font-size: 16px;
                      font-weight: 500;
                    ">
                        Number of Pass
                      </span>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12 pt-1 pb-4>
                      <v-select outlined placeholder="Folder Name" dense color="black" :items="passQuantity"
                        v-model="numberOfPass" item-text="name" item-value="name" hide-details="auto"
                        >
                        <template v-slot:append>
                          <v-icon color="black">mdi-chevron-down</v-icon>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md12 lg12>
                  <v-layout wrap justify-center>

                    <v-flex xs12 sm12 md12 lg12>
                      <span style="
                      font-size: 16px;
                      font-weight: 500;
                    ">
                        Amount
                      </span>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12 pt-1 pb-4>
                      <v-text-field outlined placeholder="Folder Name" dense color="black"
                        v-model="amountOfPass" item-text="name" item-value="name" hide-details="auto" readonly
                        >

                        <template v-slot:prepend-inner>
      <span><v-icon>mdi-currency-rupee</v-icon></span>
    </template>
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex lg12 pt-3 class="text-end">
                  <v-btn class="bgcustom" @click="addPost();">
                    <span style="
                    color: white;
                        font-size: 14px;
                        font-weight: 600;
                        text-transform: none;
                      ">
                      Submit
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>


      </v-flex>
    </v-layout>

  </div>
</template>

<script>
  import axios from "axios";  
// import CryptoJS from "crypto-js";
export default {
  components: {},
  data() {

    return {
      showSnackBar: false,
      msg: "",
      numberOfPass: "",
      passQuantity: ["10", "20", "30", "40", "50"],
      amountOfPass: "",
      feeMap: {
        "10": "336",
        "20": "672",
        "30": "1008",
        "40": "1344",
        "50": "1680",
      },
      division: [],
      divisionid:"",
      pmrNo: "",
    };
  },

  watch: {
    numberOfPass(newVal) {
      this.amountOfPass = this.feeMap[newVal] || ""; // Auto-fill the amount based on the selected number of passes
    },
  },

  mounted() {
    // this.getList();
    this.getDivision();
  },
  created() {
    this.uType = localStorage.getItem("uType");
  },

  computed: {
    user() {
      const uType = localStorage.getItem("uType");
      if (uType === "777") {
        return "admin";
      } else if (uType === "772") {
        return "user";
      } else if (uType === "773") {
        return "range";
      } else if (uType === "7741") {
        return "section";
      } else if (uType === "7742") {
        return "superclerk";
      } else {
        return "division";
      }
    },
  },

  methods: {
    getDivision() {
      this.appLoading = true;
        axios({
          method: "GET",
          url: "/get/all/divsions",
          headers: {
            token: localStorage.getItem("token"),
          },
        })
          .then((response) => {
            this.division = response.data.data;
            this.appLoading = false;
          })
          .catch((err) => {
            this.ServerError = true;
            console.log(err);
          });
    },


  },
};
</script>


<style>
.subheading {
  font-family: mainfont;
  color: #42275a;
  text-transform: none;
  font-size: 17px;
  font-weight: bold;
}

.heading {
  font-family: mainfont;
  color: white;
  text-transform: none;
  font-size: 22px;
}

.no-spinners {
  /* Remove the up and down arrows */
  appearance: textfield;
  -moz-appearance: textfield;
  -webkit-appearance: textfield;
}

.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>